import React from "react";
import "./PublishingCosts.css";

const costTiersData = [
  { label: "기본 패키지", price: "100만 원", note: "전자책 위주" },
  { label: "종이책 포함", price: "300 ~ 600만 원", note: "1,000부 기준" },
  { label: "프리미엄", price: "700만 원 ~", note: "고급 디자인, 마케팅 포함" },
];

const basicServicesData = [
  "ISBN 등록",
  "기본 편집",
  "표준 표지",
  "전자책 제작",
  "온라인 유통",
];
const additionalServicesData = [
  "전문 편집",
  "커스텀 디자인",
  "종이책 인쇄",
  "마케팅",
];

const monthlyManagementFeatures = [
  "진행사항 관리 : 출판 과정 실시간 모니터링",
  "판매 현황 확인 : 실시간 판매 데이터 조회",
  "인세 정산 : 자동 정산 및 세무 서류 제공",
  "커뮤니티 지원 : 저자 간 정보 교류 및 네트워킹",
  "저술 업무 지원 : 저술 참조 자료, 독자 소통 기능 등",
];

const paymentPlanData = [
  { label: "계약금", percentage: "30%" },
  { label: "중도금", percentage: "40%" },
  { label: "잔금", percentage: "30%" },
];

const PublishingCosts = () => {
  return (
    <>
      <div className="publishing-costs-container">
        <h1 className="page-main-title">자비 출판, 비용은 어떻게 책정될까요?</h1>

        <div className="costs-layout-grid">
          <div className="main-costs-card">
            <div className="main-costs-header">
              <h2>자비 출판 출판비용</h2>
            </div>
            <div className="main-costs-body">
              <div className="tier-items-wrapper">
                {costTiersData.map((tier, index) => (
                  <div key={index} className="cost-tier-item">
                    <span className="tier-label">{tier.label}</span>
                    <p className="tier-price">{tier.price}</p>
                    <span className="tier-note">{tier.note}</span>
                  </div>
                ))}
              </div>
              <hr className="costs-divider" />
              <div className="services-section">
                <h3>기본 서비스</h3>
                <p>{basicServicesData.join(", ")}</p>
              </div>
              <hr className="costs-divider" />
              <div className="services-section">
                <h3>추가 서비스</h3>
                <p>{additionalServicesData.join(", ")}</p>
              </div>
            </div>
          </div>

          <div className="plus-symbol">+</div>

          <div className="side-card">
            <h3>저자 스튜디오</h3>
            <p className="side-card-intro">
              저자 스튜디오를 통해 아래 서비스를 지원 받을 수 있습니다.
            </p>
            <ul>
              {monthlyManagementFeatures.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="payment-plan-section">
        <h2 className="payment-plan-title">계약금, 이렇게 진행됩니다</h2>
        <p className="payment-plan-description">
          일반적으로 계약금 30%, 중도금 40%, 잔금 30%로 3차례 분할 지급합니다.
        </p>
        <div className="payment-cards-wrapper">
          {paymentPlanData.map((item, index) => (
            <div key={index} className="payment-card">
              <p className="card-label">{item.label}</p>
              <p className="card-percentage">{item.percentage}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default PublishingCosts;
